// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Unibrow-cls1___850267682f1baaf41d1{/*!*/}.Unibrow-cls2___0b3bb00f63cb6e09e84{background-color:#fff2f2;background-color:var(--error-light, #fff2f2);color:#b60000;color:var(--text-error, #b60000)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Unibrow-cls1___850267682f1baaf41d1",
	"cls2": "Unibrow-cls2___0b3bb00f63cb6e09e84 Unibrow-cls1___850267682f1baaf41d1"
};
export default ___CSS_LOADER_EXPORT___;
